import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Input from 'components/atoms/input';
import forms from 'constants/forms';

const ClinicDetails = ({ errors, type }) => {
  let clinicDetails;
  if (type === 'clinicAdd') {
    clinicDetails = [...forms.adminPanelsClinic.clinicAdd.clinicDetails];
  } else if (type === 'clinicEdit') {
    clinicDetails = [...forms.adminPanelsClinic.clinicEdit.clinicDetails];
  }
  return (
    <div className="admin-patient-form-block">
      <span>Clinic Details</span>
      <Row>
        {clinicDetails.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} disabled={false} />
            {errors[field.id] ? (
              <div className="input-error">
                {errors[field.id].split('.')[0]}
              </div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

ClinicDetails.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  type: PropTypes.oneOf(['clinicAdd', 'clinicEdit']).isRequired,
};

export default ClinicDetails;
